import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
interface CategoryObj {
  category: string;
  backTo: string;
  dataName: string;
}

interface Pagination {
  currentPage: number;
  firstPageUrl: string;
  from: number;
  lastPage: number;
  lastPageUrl: string;
  nextPageUrl: string | null;
  path: string;
  perPage: number;
  prevPageUrl: string | null;
  to: number;
  total: number;
}

@Component
export default class HacoBase extends Vue {
  $debugServer!: string;
  pagination: Pagination = {
    currentPage: 1,
    firstPageUrl: "",
    from: 1,
    lastPage: 1,
    lastPageUrl: "",
    nextPageUrl: null,
    path: "",
    perPage: 10,
    prevPageUrl: null,
    to: 1,
    total: 1
  };

  getName(obj: any): string {
    const funcNameRegex = /function (.{1,})\(/;
    const results = funcNameRegex.exec(obj.constructor.toString());
    return results && results.length > 1 ? results[1] : "";
  }

  deleteCell(num: number, arr: []): void {
    arr.splice(num, 1);
    this.$forceUpdate();
  }

  addCell(arr: any[]): void {
    const len: number = arr.length - 1;
    const newItem: any = Object.assign({}, arr[len]);
    const sheetFrom = parseInt(newItem.sheetFrom, 10) + 1;
    newItem.sheetFrom = sheetFrom;
    newItem.sheetTo = -1;
    arr.push(newItem);
  }

  selectSelf(e: Event): void {
    if (e.target) {
      const targetEle: HTMLInputElement = e.target as HTMLInputElement;
      targetEle.select();
    }
  }

  updateInput(): void {
    this.$forceUpdate();
  }

  putPageData(data: any): void {
    this.pagination = data;
  }

  getPage(page: number | string): string {
    let newUrl: string;
    switch (page) {
      case "prev":
        newUrl = this.pagination.prevPageUrl as string;
        break;
      case "next":
        newUrl = this.pagination.nextPageUrl as string;
        break;
      default:
        newUrl = (this.pagination.path + "?page=" + page) as string;
        break;
    }
    return newUrl;
  }

  /** sheetFromのバリデーションをリセット */
  resetSheetFromEle(): boolean {
    let sheetFromEle: HTMLInputElement;
    let bool = false;
    Object.keys(document.getElementsByClassName("sheetFrom")).forEach(
      (k: string, i: number) => {
        sheetFromEle = document.getElementsByClassName("sheetFrom")[
          i
        ] as HTMLInputElement;
        sheetFromEle.setCustomValidity("");
      }
    );
    const formElement: HTMLFormElement = document.getElementById(
      "editForm"
    ) as HTMLFormElement;
    if (formElement !== null && formElement.reportValidity() === false) {
      bool = true;
    }
    return bool;
  }

  /** sheetFromのエラー表示 */
  showSheetFromError(
    sheetValueCheck: number[],
    targetClassName = "sheetFrom",
    showAlert = true
  ): void {
    const sheetFromEle: HTMLInputElement = document.getElementsByClassName(
      targetClassName
    )[sheetValueCheck[0]] as HTMLInputElement;
    sheetFromEle.setCustomValidity(
      this.$t("message.editCommon.error.invalidSheetValue") as string
    );
    if (showAlert === true) {
      this.$emit(
        "putErrorText",
        this.$t("message.editCommon.error.invalidSheetValue")
      );
    }
    console.log("[Error]", sheetValueCheck);
  }

  /** sheetToの値を設定する */
  setSheetTo(arr: any[]): void {
    let i: number;
    let j: number;
    for (i = 0; i < arr.length; i++) {
      j = i + 1;
      arr[i].sheetTo = arr[j] ? arr[j].sheetFrom - 1 : -1;
    }
  }

  checkSheetValue(arr: any[]): number[] {
    let sheetFrom: number = arr[0].sheetFrom as number;
    let prevFrom: number;
    let erroredNumber = -1;
    let i = 1;
    for (i = 1; i < arr.length; i++) {
      prevFrom = parseInt(arr[i].sheetFrom, 10);
      if (prevFrom <= sheetFrom) {
        erroredNumber = sheetFrom;
        break;
      } else {
        sheetFrom = prevFrom;
      }
    }
    return [i, erroredNumber];
  }

  getCurrentToken(): string {
    const hacoStorage: Storage = window.localStorage;
    const token: string = hacoStorage.getItem("accessToken") as string;
    return token;
  }

  setAxiosParams(
    url: string,
    accessMethod: string,
    editData: any = null,
    contentType = "application/json"
  ): object {
    const token: string = this.getCurrentToken();
    const params: object = {
      method: accessMethod,
      url: url,
      xsrfHeaderName: "X-CSRF-Token",
      withCredentials: true,
      headers: {
        "Content-Type": contentType,
        Authorization: "Bearer " + token
      },
      data: editData
    };
    return params;
  }

  deleteEditData(
    id: number,
    category: string,
    isUsed: number,
    confirmationMessage: string,
    callback: Function
  ): void {
    if (isUsed > 0) {
      /** 使われているシナリオがあると消せない */
      return;
    }
    const confirmation: boolean = confirm(confirmationMessage);
    if (confirmation === false) {
      return;
    }
    const url = this.$debugServer + "/api/v1_inner/" + category + "/" + id;
    const params: object = this.setAxiosParams(url, "delete");

    axios(params)
      .then((response: any): void => {
        if (response.data === 1 && callback) {
          /** 保存完了したら */
          callback();
        }
      })
      .catch((error: any): void => {
        console.log("[Delete Error]", error);
        this.toLoginPage(error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
      });
  }

  copyScenario(id: number, callback: Function): void {
    const url =
      this.$debugServer + "/api/v1_inner/scenario/copy_scenario/" + id;
    const params: object = this.setAxiosParams(url, "get");
    axios(params)
      .then((response: any): void => {
        if (response.data === 1 && callback) {
          /** 保存完了したら */
          this.$emit("putDialogText", this.$t("message.scenario.copied"));
          callback();
        }
      })
      .catch((error: any): void => {
        console.log("[Copy Scenario Error]", error);
        this.toLoginPage(error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
      });
  }

  scrollToResult(id: string, buffer = 50): void {
    this.$nextTick((): void => {
      const target: HTMLDivElement = document.getElementById(
        id
      ) as HTMLDivElement;
      const bounds: DOMRect = target.getBoundingClientRect() as DOMRect;
      const rectTop = bounds.top;
      const offsetTop = window.pageYOffset;
      const top = rectTop + offsetTop - buffer;
      const rectLeft = bounds.left;
      const offsetLeft = window.pageXOffset;
      const left = rectLeft + offsetLeft - buffer;
      window.scrollTo({
        top,
        left,
        behavior: "smooth"
      });
    });
  }

  toLoginPage(error: any) {
    console.log(error.response.status);
    if (error.response && error.response.status === 401) {
      this.$router.push({
        name: "home",
        params: { expired: "1" }
      });
    }
  }

  async sendEditData(
    id: number,
    editData: any,
    categoryObj: CategoryObj,
    back: boolean,
    callback: Function
  ): Promise<any> {
    let url;
    let accessMethod;
    if (id === -1) {
      /** 新規の場合 */
      url = this.$debugServer + "/api/v1_inner/" + categoryObj.category + "/";
      accessMethod = "post";
    } else {
      /** 通常の更新 */
      url =
        this.$debugServer + "/api/v1_inner/" + categoryObj.category + "/" + id;
      accessMethod = "put";
    }
    const params: object = this.setAxiosParams(url, accessMethod, editData);
    try {
      const sentData: any = await axios(params).then((response: any): void => {
        const responseDataType =
          this.getName(response.data) === "Object" && response.data.id
            ? true
            : false;
        if (response.data === 1 || responseDataType === true) {
          if (responseDataType === true) {
            /** 新規登録の場合返却されたidを設定 */
            editData[categoryObj.dataName].id = response.data.id;
          }
          /** 保存完了したら */
          this.$emit("putDialogText", this.$t("message.scenarioEdit.success"));
          if (back === true) {
            this.$router.push({
              name: categoryObj.backTo,
              params: {
                saveAndBack: "1"
              }
            });
          } else if (callback) {
            callback();
          }
        } else if (response.data.errors) {
          /** エラー情報が返ってきた場合  */
          this.$emit("putErrorText", this.$t("message.editCommon.error.error"));
          let errorList: string[] = [];
          Object.keys(response.data.errors).forEach((k: string): void => {
            errorList = errorList.concat(response.data.errors[k]);
          });
          this.$emit("putErrorList", errorList);
        }
      });
      return sentData;
    } catch (error) {
      console.log("[Putting Error]", error);
      this.toLoginPage(error);
      Object.keys(error).forEach((k: string) => {
        console.log(k, error[k]);
      });
      return error;
    }
  }
}
